import React from 'react';
import './choicebox.scss';

const ChoiceBox = () => {
    return (
        <div className="mainChoiceBox">
            <h2 className="title">Choice Box</h2>
            <div className="submainChoiceBox">
                <label className="checkboxLabel">
                    <input type="checkbox" className="input" />
                    <div className="custom-checkbox square"></div>
                </label>

                <label className="checkboxLabel">
                    <input type="checkbox" className="input" />
                    <div className="custom-checkbox circle"></div>
                </label>
            </div>
        </div>
    );
};

export default ChoiceBox;